import { useTranslation } from 'react-i18next';
import { Button, Panel } from '@/shared/ui';
import { GeoMap } from '@/shared/ui/map';
import type { StationChainFormApi } from '../useStationChainForm';
import type { StationChainEditor } from '../useStationChainEditor';
import { buildChainMarkers } from './chainStopUtils';

export interface StationChainMapPanelProps {
  form: StationChainFormApi;
  editor: StationChainEditor;
}

/** Panel s mapou trasy — sekvenční linie + číslované markery v barvě trasy, „Stanice z mapy" a vystředění. */
export function StationChainMapPanel({ form, editor }: StationChainMapPanelProps) {
  const { mapMode, startNewStationFromMap, handleMapClick, fit, fitSignal } = editor;

  const { t } = useTranslation('products');

  return (
    <div className="min-h-0 flex-1">
      <Panel
        variant="filled"
        icon="map"
        title={t('stationChain.map.title')}
        padded={false}
        className="flex h-full min-h-0 flex-col"
        actions={
          <>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              iconLeft="pin"
              data-active={mapMode.kind === 'new-station' ? '' : undefined}
              onClick={startNewStationFromMap}
            >
              {t('stationChain.map.newStation')}
            </Button>
            <Button type="button" variant="ghost" size="sm" onClick={fit}>
              {t('stationChain.map.fit')}
            </Button>
          </>
        }
        footer={<span className="text-phx-text-muted text-phx-xs">{t('stationChain.map.legend')}</span>}
      >
        <div className="relative h-full min-h-0">
          {mapMode.kind !== 'idle' ? (
            <div className="rounded-phx top-phx-3 bg-phx-text text-phx-xs px-phx-3 py-phx-1 absolute left-1/2 z-[1000] -translate-x-1/2 text-white shadow">
              {t('stationChain.map.newStationHint')}
            </div>
          ) : null}
          <form.Subscribe
            selector={(state) => ({ stops: state.values.stops, color: state.values.color })}
          >
            {({ stops, color }) => (
              <GeoMap
                markers={buildChainMarkers(stops, color)}
                connections="sequence"
                lineColor={color}
                fitSignal={fitSignal}
                onMapClick={mapMode.kind === 'idle' ? undefined : handleMapClick}
              />
            )}
          </form.Subscribe>
        </div>
      </Panel>
    </div>
  );
}
